import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { PageContainer } from 'components/shared';
import CheckView from 'components/shared/views/CheckView';
import { PrimaryButton, SecondaryButton } from 'components/ui';
import Classes from "model";
import React from 'react';
import "./styles.css";

/**
 * @function CheckImageBackConfirmManualPage
 * @return {React.Component}
 * @exported true
 * @description A page in the "deposit a check" workflow.
 */

export default function CheckImageBackConfirmManualPage(props) {
  const { goStep, prevStep } = useWorkflow() ?? {};
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  const data = { ...getDefaultPageData(), ...props.data ?? {} };
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

  const state = { data, ui };
  const mobileDepositsVersion = data.mobileDepositsVersion ?? {};

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onRetakeClick: () => goStep(8),
      
      onUseClick: () => {
        if(mobileDepositsVersion.version === "manual front & back images") {
          const updatedState = BCMSStateManagerCRUD.init(state)
          .update(["ui", "checkBackView" , "isSet"], true)
          .submit();
          goStep(0, updatedState);
        } else if(mobileDepositsVersion.version === "manual check images") {
          const updatedState = BCMSStateManagerCRUD.init(state)
          .update(["ui", "checkFrontView" , "isSet"], true)
          .update(["ui", "checkBackView" , "isSet"], true)
          .submit();
          goStep(0, updatedState);
        } else {
          const updatedState = BCMSStateManagerCRUD.init(state)
          .update(["ui", "checkFrontView" , "isSet"], true)
          .update(["ui", "checkBackView" , "isSet"], true)
          .submit();
          goStep(0, updatedState);
        }
      },
  });

  return(
    <PageContainer className={ `check-image-back-confirm-manual-page ${ props.className ?? "" }` } state={state} controller={controller}>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultPageData = () => ({
  
});
export const getDefaultPageUI = () => ({
  
});

function PageContent() {
  const { onRetakeClick, onUseClick } = useStateManager();
  
  return (
    <div className="check-image-page-content flex-container flex-vertical">
      <CheckView checkSide="CheckBack" />
      <div className="check-overlay-container">
        <div className="overlay-item-container flex-container flex-vertical align-center justify-right">
          <div className="flex-container flex-horizontal align-center button-container">
            <SecondaryButton text="Retake" dataPoint="Check_Image_Back_Confirm_Manual_Retake_Button" onClick={ onRetakeClick } />
            <PrimaryButton text="Use" dataPoint="Check_Image_Back_Confirm_Manual_Use_Button" onClick={ onUseClick } />
          </div>
        </div>
      </div> 
    </div>
  );
}